import CardComponent from './CardComponent';

export class ButtonCall extends CardComponent {}
